import React, { useEffect, useMemo, useState } from 'react';
import Dropdown from '../common/dropdown/Dropdown';
import DateInput from '../components/global/DateInput';
import Wrapper from '../components/global/Wrapper';
import SettingHeader from '../components/SettingPage/SettingHeader';
import countryList from 'react-select-country-list';
// import countryCodes from 'country-codes-list';
import { OptionType, TUserloggedInDetails, TUserProfile } from '../types';
import { useMutation, useQuery } from 'react-query';
import axios, { AxiosError } from 'axios';
import { baseUrl_, timeout } from '../utils/constants';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { setLoggedInUserDetails } from '../features/authentication/authSlice';
import { toast } from 'react-toastify';
import { handleError } from '../utils/errorHandler';
import Button from '../components/global/Button';
import moment from 'moment';
import { countryCodes } from '../utils/countryCodes';
import jwtDecode from 'jwt-decode';
import { ClipLoader } from 'react-spinners';
import { wqkgx } from '../config/keys';
import CryptoJS from 'crypto-js';
import { decryptJson } from '../utils/decryptJson';
import { encryptData } from '../utils/encryptJson';
import { logUserOut } from '../utils/logUserOut';
import { useSearchParams, useNavigate } from 'react-router-dom';
import customToast, { ToastType } from '../components_/Toast';
import { Request } from '../apis/request';

const EditSettings = () => {
  const [searchParams] = useSearchParams();
  const step = searchParams.get('step');
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [secondaryPhone, setsecondaryPhone] = useState('');
  const [newDetailsSet, setnewdetailsset] = useState(false);

  const [primary, setPrimary] = useState(false);
  // const [addSecondaryNumber, setAddSecondaryNumber] = useState(false);
  const [date, setDate] = useState('');
  const token: any = localStorage.getItem('login-token');
  const [deets, setDeets] = useState<TUserloggedInDetails>({} as TUserloggedInDetails);
  const [bvnRes, setBvnRes] = useState<any>({});
  const [disabled, setDisabled] = useState(true);
  const [firstNameMatch, setFirstNameMatch] = useState(true);
  const [lastNameMatch, setlastNameMatch] = useState(true);
  const [middleNameMatch, setmiddleNameMatch] = useState(true);
  const [dobMatch, setdobMatch] = useState(true);

  const [bvnEnabled, setBvnEnabled] = useState(false);

  const details: any = jwtDecode(token);
  const { id } = details;

  // console.log(details);

  const [newDetails, setNewDetails] = useState<TUserloggedInDetails>({} as TUserloggedInDetails);

  const fetchUserInfo = async () => {
    const res = await Request.get(`/user/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        sessId: localStorage.getItem('sessId') ?? '',
      },
      timeout: timeout,
    });
    return res;
  };
  const fetchingUserInfo = useQuery('user-info-2', fetchUserInfo, {
    onSuccess: (data) => {
      if (!newDetailsSet) {
        const res = decryptJson(data?.data?.data);
        setNewDetails(res?.user);
        setnewdetailsset(true);
      }
    },
    onError: (error: AxiosError<{ message: string; status?: number }>) => {
      // handleError({ error, errorFn });
      if (error?.response?.data?.status === 593) {
        logUserOut(error?.response?.data?.status);
      }
      customToast('an error occured, please try again', ToastType.error);
    },
  });

  const verifyBvnInfo = useMutation(
    (data: { bvn: string }) =>
      Request.post(
        `${baseUrl_}/verify/bvn`,
        encryptData({
          bvn: CryptoJS.AES.encrypt(data.bvn, wqkgx).toString(),
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            sessId: localStorage.getItem('sessId') ?? '',
          },
          timeout: timeout,
        },
      ),
    {
      onSuccess: async (data) => {
        const res = decryptJson(data?.data?.data);
        setBvnRes(res);

        // console.log({ bvnRes })
        if (data.status) {
          customToast('BVN verified successfully', ToastType.success);
        } else {
          customToast(`bvn doesn't match`, ToastType.error);
        }
      },
      onError: (error: AxiosError<{ message: string }>) => {
        setBvnRes({});
        handleError({ error, errorFn });
        customToast('an error occured, please check and try again', ToastType.error);
      },
    },
  );

  const verifyBvnInfoFn = (data: any) => {
    verifyBvnInfo.mutate(data);
  };

  const countries = useMemo(() => countryList().getData(), []);
  const getCountryValue = (label: string) => {
    const val = countries.find((country) => country?.label === label)?.value;
    return val;
  };
  const [selectedCountry, setSelectedCountry] = useState<OptionType>({
    value: 'Country of residence',
    label: 'Country of residence',
  });

  const [selectedCountrysec, setSelectedCountrysec] = useState<OptionType>({
    value: 'Country of residence',
    label: 'Country of residence',
  });

  useEffect(() => {
    if (newDetails?.bvn?.length === 11) {
      verifyBvnInfoFn({ bvn: newDetails?.bvn });
    }
  }, [newDetails?.bvn]);

  useEffect(() => {
    if (
      newDetails?.firstName &&
      newDetails?.lastName &&
      (date || newDetails?.dateOfBirth) &&
      newDetails?.bvn?.length === 11 &&
      bvnRes?.Bvn
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [newDetails, bvnRes, date]);

  const codes: any = countryCodes;
  const dispatch = useAppDispatch();
  const showErrorToastMessage = (errmsg: string) => {
    customToast(errmsg, ToastType.error);
  };

  const errorFn = (error: AxiosError<{ message: string }>) => {
    if (error?.response?.data?.message) {
      showErrorToastMessage(error.response.data.message);
    } else {
      showErrorToastMessage('Something went wrong');
    }
  };

  const updateUserInfo = useMutation(
    (data: TUserloggedInDetails) =>
      Request.patch(`/user`, encryptData(data), {
        headers: {
          Authorization: `Bearer ${token ?? ''}`,
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout: timeout,
      }),
    {
      onSuccess: (data) => {
        const details = decryptJson(data?.data?.data);
        delete details.token;
        dispatch(setLoggedInUserDetails(details));
        customToast('Changes saved successfully', ToastType.success);
      },
      onError: (error: AxiosError<{ message: string; status?: number }>) => {
        // handleError({ error, errorFn });
        if (error?.response?.data?.status === 593) {
          logUserOut(error?.response?.data?.status);
        }
        customToast('an error occured, please try again', ToastType.error);
      },
    },
  );

  useEffect(() => {
    if (newDetails?.firstName && newDetails?.lastName) {
      setBvnEnabled(true);
    } else {
      setBvnEnabled(false);
    }
  }, [newDetails]);

  useEffect(() => {
    if (
      bvnRes?.FirstName &&
      bvnRes?.FirstName?.toLowerCase() !== newDetails?.firstName?.toLowerCase()
    ) {
      setFirstNameMatch(false);
    } else {
      setFirstNameMatch(true);
    }
    if (
      bvnRes?.LastName &&
      bvnRes?.LastName?.toLowerCase() !== newDetails?.lastName?.toLowerCase()
    ) {
      setlastNameMatch(false);
    } else {
      setlastNameMatch(true);
    }
    // if (
    //   bvnRes?.MiddleName &&
    //   bvnRes?.MiddleName?.toLowerCase() !== newDetails?.middleName?.toLowerCase()
    // ) {
    //   setmiddleNameMatch(false);
    // } else {
    //   setmiddleNameMatch(true);
    // }
  }, [newDetails, bvnRes]);

  return (
    <Wrapper className=' space-y-3 pt-[12px] md:pt-12 md:space-y-8  !mr-0'>
      <div className='md:w-full lg:w-[700px] md:mx-auto  md:px-[35px]'>
        <SettingHeader title='Edit Personal Profile' desc='Complete all required information' />

        <form>
          <div className=' mb-[68px]'>
            <div className='text-[#F51010]  flex items-center text-[15px] font-normal mt-[15px]'>
              *<div className='ml-[7px]'>Compulsory fields</div>
            </div>
          </div>
          {fetchingUserInfo?.isLoading ? (
            <div className='mt-[20%] w-[100%] flex justify-center items-center'>
              <div>
                <div className='flex justify-center'>
                  <ClipLoader color={'#F8B400'} loading={fetchingUserInfo?.isLoading} size={50} />
                </div>
                Please wait, fetching your info...
              </div>
            </div>
          ) : (
            <>
              <div>
                <div className='mb-[27px] flex items-center w-full'>
                  <div className='w-full'>
                    <label className='flex justify-between items-center relative text-[13px] mb-[5px] text-[#212121] '>
                      First name
                      {!firstNameMatch && (
                        <p className='text-xs text-[#F51010] mt-[10px]'>
                          First name does not match with the first name on your bvn
                        </p>
                      )}
                    </label>

                    <input
                      className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                      onChange={(e) => {
                        setNewDetails({ ...newDetails, firstName: e.target.value });
                      }}
                      value={newDetails?.firstName ?? deets?.firstName}
                      readOnly={
                        bvnRes?.FirstName &&
                        bvnRes?.FirstName?.toLowerCase() === newDetails?.firstName?.toLowerCase()
                      }
                    />
                  </div>
                  <div className='md:ml-[10px] text-[#F51010] mt-[15px] '>*</div>
                </div>
                <div className='mb-[27px] flex items-center w-full'>
                  <div className='w-full'>
                    <label className='flex items-center justify-between relative text-[13px] mb-[5px] text-[#212121] '>
                      Middle name
                      {!middleNameMatch && (
                        <p className='text-xs text-[#F51010] mt-[10px]'>
                          Middle name does not match with the first name on your bvn
                        </p>
                      )}
                    </label>

                    <input
                      className='w-full  h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                      onChange={(e) => {
                        setNewDetails({ ...newDetails, middleName: e.target.value });
                      }}
                      value={newDetails?.middleName ?? deets?.middleName}
                      readOnly={
                        bvnRes?.MiddleName &&
                        bvnRes?.MiddleName?.toLowerCase() === newDetails?.middleName?.toLowerCase()
                      }
                    />
                  </div>
                  <div className='md:ml-[10px] text-[#F51010] mt-[15px] '>*</div>
                </div>
                <div className='mb-[27px] flex items-center w-full'>
                  <div className='w-full'>
                    <label className='flex items-center justify-between relative text-[13px] mb-[5px] text-[#212121] '>
                      Last name
                      {!lastNameMatch && (
                        <p className='text-xs text-[#F51010] mt-[10px]'>
                          Last name does not match with the first name on your bvn
                        </p>
                      )}
                    </label>

                    <input
                      className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                      onChange={(e) => {
                        setNewDetails({ ...newDetails, lastName: e.target.value });
                      }}
                      value={newDetails?.lastName ?? deets?.lastName}
                      readOnly={
                        bvnRes?.LastName &&
                        bvnRes?.LastName?.toLowerCase() === newDetails?.lastName?.toLowerCase()
                      }
                    />
                  </div>
                  <div className='md:ml-[10px] text-[#F51010] mt-[15px] '>*</div>
                </div>
                <div className='mb-[27px] flex items-center w-full'>
                  <div className='w-full'>
                    <DateInput
                      className='!py-[6px]'
                      placeholderText='Enter your birth date'
                      value={date ? date : newDetails?.dateOfBirth}
                      onChange={(e: any) => {
                        setDate(e);
                        setNewDetails({
                          ...newDetails,
                          dateOfBirth: moment(newDetails?.dateOfBirth).format('YYYY-MM-DD'),
                        });
                      }}
                    />
                  </div>
                  <div className='md:ml-[10px] text-[#F51010] mt-[15px] '>*</div>
                </div>
                <div>
                  <div className='mb-[27px] flex items-center w-full'>
                    <div className='w-full'>
                      <label className='flex justify-between items-center relative text-[13px] mb-[5px] text-[#212121] '>
                        Bank Verification Number (BVN)
                        <span className='p-[10px] bg-[#0287891A] text-green text-[13px] font-Poppins '>
                          Why need this?
                        </span>
                      </label>
                      <input
                        className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                        onChange={(e) => {
                          const re = /^[0-9\b]+$/;
                          if (
                            (e.target.value === '' || re.test(e.target.value)) &&
                            !verifyBvnInfo?.isLoading
                          ) {
                            setNewDetails({ ...newDetails, bvn: e.target.value });
                          }
                        }}
                        value={newDetails?.bvn}
                        maxLength={11}
                        readOnly={!bvnEnabled}
                      />
                    </div>
                    <div className='md:ml-[10px] text-[#F51010] mt-[15px] '>*</div>
                  </div>
                  {verifyBvnInfo?.isLoading && (
                    <p>Please wait, we are verifying if your bvn matches your details</p>
                  )}
                  {/* {
                    (!newDetails?.bvn) &&
                    <p className='text-xs font-Poppins text-[#F51010]'>
                        Please enter your bvn
                    </p>
                  } */}
                  {newDetails?.bvn?.length === 11 &&
                    !verifyBvnInfo?.isLoading &&
                    (!firstNameMatch || !lastNameMatch || !middleNameMatch) && (
                      <div className='flex items-center md:pl-2 md:pr-4 mr-4 space-x-2 bg-[#F510101A]'>
                        <svg
                          width='41'
                          height='41'
                          viewBox='0 0 41 41'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <path
                            d='M10.21 18.3779C10.21 13.8669 13.8669 10.21 18.3779 10.21H22.4619C26.973 10.21 30.6299 13.8669 30.6299 18.3779V22.4619C30.6299 26.973 26.973 30.6299 22.4619 30.6299H18.3779C13.8669 30.6299 10.21 26.973 10.21 22.4619V18.3779Z'
                            fill='#F51010'
                            fillOpacity='0.13'
                          />
                          <path
                            d='M24.2676 17.0462L16.5752 24.7386'
                            stroke='#F51010'
                            strokeWidth='1.53149'
                            strokeMiterlimit='10'
                            strokeLinecap='round'
                          />
                          <path
                            d='M24.2686 24.7377L16.5762 17.0453'
                            stroke='#F51010'
                            strokeWidth='1.53149'
                            strokeMiterlimit='10'
                            strokeLinecap='round'
                          />
                        </svg>

                        <p className='text-xs font-Poppins'>
                          The BVN provided does not match the information above. Kindly enter the
                          correct BVN that matches the information.
                        </p>
                      </div>
                    )}
                </div>
                <div className='mb-[27px] mt-[41px] w-full md:w-[615px]  '>
                  <Dropdown
                    className='border   rounded-[2px] py-[8px] '
                    label='Gender'
                    placeholder={newDetails?.gender ?? 'Select'}
                    labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                    options={[
                      { value: 'Male', label: 'Male' },
                      { value: 'Female', label: 'Female' },
                    ]}
                    width='100%'
                    setSelectedOption={(e: any) => {
                      setNewDetails({ ...newDetails, gender: e.value.toLowerCase() });
                    }}
                  />
                </div>
                <div className='mb-[27px] w-full md:w-[615px] '>
                  <label className='flex items-center text-[13px] relative mb-[5px] text-[#212121] '>
                    Email Address
                  </label>
                  <input
                    className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                    onChange={(e) => {
                      setNewDetails({ ...newDetails, email: e.target.value?.toLowerCase() });
                    }}
                    value={newDetails?.email ?? deets?.email}
                  />
                </div>
                <div className='mb-[27px] w-full md:w-[615px] '>
                  <Dropdown
                    className='border   rounded-[2px] py-[8px] '
                    label='Country of residence'
                    placeholder={newDetails?.country ? newDetails?.country.value : 'Nigeria'}
                    labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                    options={countries.map((country) => {
                      return {
                        value: country.label,
                        label: country.label,
                        // name: country.value,
                      };
                    })}
                    setSelectedOption={(e: any) => setNewDetails({ ...newDetails, country: e })}
                    width='100%'
                    value={newDetails?.country ?? newDetails?.country}
                  />
                </div>
                <div className='w-full md:w-[615px] '>
                  <h4 className='text-green text-[19px] font-Poppins font-normal my-[20px] '>
                    Primary number{' '}
                  </h4>
                  <label className='flex items-center relative text-[13px] mb-[5px] text-[#212121] '>
                    Phone number
                  </label>
                  <div
                    style={{ position: 'relative' }}
                    className='flex flex-row w-[100%] items-end'
                  >
                    <div
                      style={{
                        border: '1px solid #798396',
                        borderRadius: '2px',
                        height: '52px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#798396',
                      }}
                      className='w-[30%] md:w-[10%]'
                    >
                      {codes[getCountryValue(newDetails?.country) ?? 'NG']}
                    </div>
                    <input
                      className='w-full h-[52px] px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                      onChange={(e) => {
                        const re = /^[0-9\b]+$/;
                        const code = codes[newDetails?.country?.value ?? 'NG'] ?? `+234`;
                        if (e.target.value === '' || re.test(e.target.value)) {
                          setPhoneNumber(e.target.value);
                          setNewDetails({ ...newDetails, phoneNumber: code + e.target.value });
                        }
                      }}
                      value={
                        phoneNumber
                          ? phoneNumber
                          : newDetails?.phoneNumber?.slice(
                              codes[newDetails?.country?.value ?? 'NG']?.length,
                            )
                      }
                    />
                  </div>
                </div>
              </div>
              <Button
                type='button'
                loading={updateUserInfo?.isLoading}
                disabled={disabled}
                onClick={() => {
                  date
                    ? updateUserInfo.mutate({
                        ...newDetails,
                        secondaryCountry: newDetails?.secondaryCountry?.label,
                        country: newDetails?.country?.label,
                        bvn: CryptoJS.AES.encrypt(newDetails?.bvn ?? '', wqkgx).toString(),
                        dateOfBirth: moment(date).format('YYYY-MM-DD'),
                      })
                    : updateUserInfo.mutate({
                        ...newDetails,
                        secondaryCountry: newDetails?.secondaryCountry?.label,
                        bvn: CryptoJS.AES.encrypt(newDetails?.bvn ?? '', wqkgx).toString(),
                        country: newDetails?.country?.label,
                        dateOfBirth: moment(newDetails?.dateOfBirth).format('YYYY-MM-DD'),
                      });
                  navigate('/settings/security?step=2');
                }}
                className='text-[13px] font-Poppins font-medium text-white mt-9 bg-green rounded-sm !py-[9px] !px-[49px]'
              >
                SAVE CHANGES
              </Button>
            </>
          )}
        </form>
      </div>
    </Wrapper>
  );
};

export default EditSettings;
